import { ReactNode } from "react";
import { Alert } from "@zapier/design-system";
import { ProgressBar } from "../ProgressBar";
import styles from "./BannerWrapperV2.module.css";
import { UpgradeAlert } from "../UpgradeAlert/UpgradeAlert";
import { useAtomValue } from "jotai";
import { isAiPageAtom, togglesAtom } from "@zapier/canvas-state";
import classNames from "classnames";

type Props = {
  alert?: string;
  children?: ReactNode;
  showProgress?: boolean;
};

export function BannerWrapperV2({
  alert,
  children,
  showProgress = false,
}: Props) {
  const toggles = useAtomValue(togglesAtom);
  const isAiPage = useAtomValue(isAiPageAtom);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.aiCanvasComposer]: toggles.aiCanvasComposer && isAiPage,
      })}
    >
      <Alert variant="banner">
        <div className={styles.buttonsWrapper}>{children}</div>
      </Alert>
      {showProgress && (
        <div className={styles.fixedProgressBarWrapper}>
          <ProgressBar />
        </div>
      )}
      {alert && <UpgradeAlert title={alert} />}
    </div>
  );
}
